import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { IComponent } from "../share/interfaces";

// services
import * as srv from "../share/services";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: "app-main",
	templateUrl: "./main.component.html",
	styleUrls: ["./main.component.scss"]
})
export class MainComponent implements IComponent, OnInit {
	// implement icomponent
	name = "MainComponent";
	subscriptions: Subscription[] = [];

	// implement local
	termsAgreed = false;
	levelSelected = false;
	nolevel: number = 0;
	yeslevel: number = 0;

	disableLevel1: boolean = false;
	disableLevel2: boolean = false;
	disableLevel3: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private _applicationSrv: srv.ApplicationService,
		private _logSrv: srv.LogService,
		private _userSrv: srv.UserService,
		private _loaderSrv: srv.LoaderService,
		private _helperSrv: srv.HelperService,
		private _storageSrv: srv.StorageService
	) { }

	ngOnInit() {
		//Subscriptions

		this.subscriptions.push(
			this.route.queryParams.subscribe(params => {
				// Defaults to 0 if no query param provided.
				this.nolevel = +params["nolevel"] || 0;
				this.yeslevel = +params["yeslevel"] || 0;

				if (this.nolevel > 0 || this.yeslevel > 0) {
					this._applicationSrv.ApplicationModel = undefined;
				}


				if (this.nolevel > 0) {
					//UPGRADE
					if (this.nolevel == 3) {
						this.disableLevel3 = true;
					}
					else if (this.nolevel == 2) {
						this.disableLevel2 = true;
						this.disableLevel3 = true;
					}
				}


				if (this.yeslevel > 0) {

					//RENEWAL
					this.disableLevel1 = true; this.disableLevel2 = true; this.disableLevel3 = true;

					if (this.yeslevel == 3) {
						this.disableLevel3 = false;
					}
					else if (this.yeslevel == 2) {
						this.disableLevel2 = false;
					}
					else if (this.yeslevel == 1) {
						this.disableLevel1 = false;
					}
				}

			})
		);

		this.subscriptions.push(
			this._userSrv.CONTACT.subscribe(contact => {
				if (contact !== undefined) {
					this._loaderSrv.SetLoading(this.name, false);
				}
			})
		);

		this.subscriptions.push(
			this._applicationSrv.OnLevelSelected$.subscribe(level => {
				"updating level selection".logWithObject(this.name, [level]);
				this.levelSelected = +level > 0;
			})
		);

		this.subscriptions.push(
			this._applicationSrv.OnTermsAgreed$.subscribe(agreed => {
				"updating terms agreed".logWithObject(this.name, [agreed]);
				this.termsAgreed = agreed;
			})
		);
	}

	OnSave() {
		this._logSrv.Debug(this.name, ["OnSave", this._applicationSrv]);
		let isUpgrade = this.nolevel > 0;
		this._helperSrv.goToLevel(
			this._applicationSrv.LEVEL,
			"get guid".EmptyGuid(),
			isUpgrade
		);
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/main/main.component.ts